'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './gallery-show.routes';

export class GalleryShowComponent {

  constructor($stateParams, GalleryService, Auth, dialogs, $state, $timeout, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.isAdmin = Auth.isAdminSync;
    this.userId = Auth.getCurrentUserSync()._id;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$timeout = $timeout;

    this.GalleryService = GalleryService;

    this.galleryId = $stateParams.id;

    let METHOD = (this.public) ? "getPublic" : "get";

    this.GalleryService[METHOD]({id: this.galleryId}, gallery => {
      this.data = gallery;

      this.galleryImages = this.data.images.map(img => {

        let imageUrl = (this.public)
          ? "/api/storage/public/"+img.image+"/ctx/"+btoa("gallery:"+this.galleryId)
          : "/api/storage/" + img.image;

        return {
          url: imageUrl,
          //extUrl: (this.public) ? null : "/api/storage/" + img.image + "/download",
          thumbUrl: '/api/storage/' + img.image + '/thumb',
          title: img.title
        };
      });

    }, err => {
      console.log("Could not retrieve gallery from server");
    })
  }

  $postLink() {
    var isPublic = !!this.public;
    this.$timeout(() => {

      var working = false;

      var doApplyChanges = function() {
        if (working) return;

        working = true;
        jQuery("div.thumb").each(function() {
          var title = jQuery(this).attr('title');

          if (!isPublic) {
            let imageThumbPathCss = jQuery(this).css('background-image');
            let imageThumbPath = imageThumbPathCss.match(/\/api.*?thumb/);

            if (imageThumbPath && Array.isArray(imageThumbPath) && imageThumbPath[0]) {
              let downloadPath = imageThumbPath[0].replace('thumb','download');
              jQuery(this).append("<div class='gallery-image-inline-download-link' title='Download Image'><a target='_blank' onclick='event.stopPropagation()' href='"+downloadPath+"'><i class='fa fa-fw fa-download'></i></a></div>");
            }
          }

          if (title) {
            jQuery(this).removeAttr('title');
            jQuery(this).append("<div class='gallery-image-inline-description'>" + title + "</div>");
          }
        });
        working = false;
      };

      doApplyChanges();

      jQuery("#gallery").on('DOMSubtreeModified', (e) => {
        doApplyChanges();
      });

    },1000);
  }

  getUserShort(user) {
    return (user) ? user.firstName + " " + user.lastName[0] + "." : "unknown";
  }

  isOwner() {
    return this.data.meta.creationUser == this.userId;
  }

  delete() {
    var that = this;

    var dlg = this.dialogs.confirm("Delete this gallery?", "Do you really want to delete this image gallery?");
    dlg.result.then(() => {
      // OK delete it
      that.GalleryService.delete({id: that.data._id},
        () => {
          that.$state.go(that.data.type + "-gallery-list");
        },
        err => {
          alert("Could not delete image gallery");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduApp.galleryShow', [uiRouter])
  .config(routes)
  .component('galleryShow', {
    template: require('./gallery-show.html'),
    controller: GalleryShowComponent,
    controllerAs: 'ctrl',
    bindings: {
      public: '<'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/gallery/show/gallery-show.component.js